<template>
    <div class="each-component">
        <div class="flex-center position-ref full-height">
            <div class="text-left padding-x30">
                <h1>Access Denied</h1>
                <p>Access is denied. You may not have the appropriate permissions to access the page or perform the action.</p>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        created() {
            this.$root.loading = false;
        }
    }
</script>


<style lang="css" scoped>

    .full-height {
        height: 80vh;
    }

    .flex-center {
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .position-ref {
        position: relative;
    }

</style>